import React from 'react';
import { Link } from 'react-router-dom';

const PhoneMockup = ({ children, rotate = 0, scale = 1 }) => (
  <div
    className="relative w-[260px] h-[540px] mx-auto"
    style={{ transform: `rotate(${rotate}deg) scale(${scale})` }}
  >
    <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-black rounded-[42px] shadow-2xl border-[3px] border-gray-700"></div>
    <div className="absolute -left-1 top-24 w-1 h-8 bg-gray-700 rounded-l"></div>
    <div className="absolute -left-1 top-36 w-1 h-14 bg-gray-700 rounded-l"></div>
    <div className="absolute -left-1 top-52 w-1 h-14 bg-gray-700 rounded-l"></div>
    <div className="absolute -right-1 top-32 w-1 h-20 bg-gray-700 rounded-r"></div>
    <div className="absolute inset-[6px] rounded-[36px] overflow-hidden bg-white">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-6 bg-black rounded-b-2xl z-20"></div>
      <div className="relative z-10 flex justify-between items-center px-5 pt-1.5 pb-1 text-[10px] font-semibold text-gray-800 bg-white">
        <span>9:41</span>
        <span className="flex items-center gap-1">
          <i className="fas fa-signal text-[8px]"></i>
          <i className="fas fa-wifi text-[8px]"></i>
          <i className="fas fa-battery-three-quarters text-[9px]"></i>
        </span>
      </div>
      <div className="absolute top-7 left-0 right-0 bottom-0 overflow-hidden">{children}</div>
    </div>
  </div>
);

const HomeScreen = () => (
  <div className="h-full bg-gradient-to-br from-blue-50 via-white to-orange-50 p-4">
    <div className="flex items-center gap-2 mb-4">
      <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-orange-500 rounded-lg flex items-center justify-center text-white">
        <i className="fas fa-store text-sm"></i>
      </div>
      <div>
        <p className="text-[9px] uppercase tracking-wider text-gray-400 font-bold leading-none">Ashop</p>
        <p className="text-xs font-bold text-gray-800 leading-none mt-0.5">Rotterdam</p>
      </div>
      <div className="ml-auto w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
        <i className="fas fa-bell text-gray-500 text-xs"></i>
      </div>
    </div>
    <div className="bg-gradient-to-br from-indigo-600 to-purple-700 rounded-2xl p-4 text-white mb-3 shadow-lg">
      <p className="text-[9px] uppercase tracking-wider font-bold opacity-80">Welcome</p>
      <p className="text-lg font-bold leading-tight mt-1">Track your package</p>
      <p className="text-[10px] opacity-90 mt-1">Snap a photo of your slip or search by name</p>
      <button className="mt-3 bg-white text-indigo-700 text-[11px] font-bold px-3 py-1.5 rounded-full">Get Started →</button>
    </div>
    <p className="text-[10px] uppercase tracking-wider text-gray-500 font-bold mb-2">Quick Actions</p>
    <div className="grid grid-cols-3 gap-2 mb-3">
      {[
        { icon: 'fa-camera', label: 'Scan', color: 'bg-emerald-500' },
        { icon: 'fa-magnifying-glass', label: 'Search', color: 'bg-blue-500' },
        { icon: 'fa-bell', label: 'Alerts', color: 'bg-orange-500' },
      ].map((a) => (
        <div key={a.label} className="bg-white rounded-xl p-3 shadow-sm flex flex-col items-center gap-1 border border-gray-100">
          <div className={`w-8 h-8 ${a.color} rounded-lg flex items-center justify-center text-white`}>
            <i className={`fas ${a.icon} text-xs`}></i>
          </div>
          <span className="text-[9px] font-semibold text-gray-700">{a.label}</span>
        </div>
      ))}
    </div>
    <p className="text-[10px] uppercase tracking-wider text-gray-500 font-bold mb-2">Recent</p>
    <div className="space-y-2">
      {[
        { name: 'Ayaz Khan', status: 'Ready to pick up', color: 'text-emerald-600', bg: 'bg-emerald-50' },
        { name: 'Sarah Ali', status: 'Arrived today', color: 'text-blue-600', bg: 'bg-blue-50' },
      ].map((p) => (
        <div key={p.name} className={`${p.bg} rounded-xl p-2.5 flex items-center gap-2`}>
          <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
            <i className="fas fa-box text-gray-400 text-xs"></i>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-[11px] font-bold text-gray-800 truncate">{p.name}</p>
            <p className={`text-[9px] font-semibold ${p.color}`}>{p.status}</p>
          </div>
          <i className="fas fa-chevron-right text-gray-300 text-[10px]"></i>
        </div>
      ))}
    </div>
  </div>
);

const ScannerScreen = () => (
  <div className="h-full bg-gray-900 relative">
    <div className="h-full flex items-center justify-center bg-gradient-to-br from-gray-800 via-gray-900 to-black">
      <div className="w-52 h-40 border-4 border-white/60 rounded-xl relative">
        <div className="absolute -top-1 -left-1 w-4 h-4 border-t-4 border-l-4 border-orange-400"></div>
        <div className="absolute -top-1 -right-1 w-4 h-4 border-t-4 border-r-4 border-orange-400"></div>
        <div className="absolute -bottom-1 -left-1 w-4 h-4 border-b-4 border-l-4 border-orange-400"></div>
        <div className="absolute -bottom-1 -right-1 w-4 h-4 border-b-4 border-r-4 border-orange-400"></div>
        <div className="absolute inset-x-0 top-1/2 h-0.5 bg-orange-400 shadow-[0_0_10px_2px_rgba(251,146,60,0.8)]"></div>
      </div>
    </div>
    <div className="absolute top-2 left-0 right-0 flex items-center justify-between px-4">
      <div className="w-8 h-8 bg-black/40 rounded-full flex items-center justify-center backdrop-blur">
        <i className="fas fa-xmark text-white text-xs"></i>
      </div>
      <p className="text-white text-xs font-bold">Scan Label</p>
      <div className="w-8 h-8 bg-black/40 rounded-full flex items-center justify-center backdrop-blur">
        <i className="fas fa-bolt text-white text-xs"></i>
      </div>
    </div>
    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4">
      <p className="text-white text-[10px] text-center mb-3 opacity-80">Position slip inside the frame</p>
      <div className="flex items-center justify-around">
        <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center backdrop-blur">
          <i className="fas fa-image text-white text-sm"></i>
        </div>
        <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center shadow-2xl">
          <div className="w-11 h-11 border-4 border-gray-800 rounded-full"></div>
        </div>
        <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center backdrop-blur">
          <i className="fas fa-camera-rotate text-white text-sm"></i>
        </div>
      </div>
    </div>
  </div>
);

const DetailsScreen = () => (
  <div className="h-full bg-gradient-to-br from-emerald-50 via-white to-teal-50 p-4">
    <div className="flex items-center gap-2 mb-3">
      <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
        <i className="fas fa-arrow-left text-gray-600 text-xs"></i>
      </div>
      <p className="text-xs font-bold text-gray-800">Your Package</p>
    </div>
    <div className="bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl p-4 text-white text-center mb-3 shadow-lg">
      <i className="fas fa-circle-check text-2xl mb-1"></i>
      <p className="text-xs font-black uppercase tracking-wider">Ready to Pick Up</p>
      <p className="text-[10px] opacity-90 mt-0.5">Arrived 2 days ago</p>
    </div>
    <div className="bg-white rounded-xl p-3 mb-3 shadow-sm border border-gray-100">
      <div className="flex items-center gap-2 mb-2">
        <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center">
          <i className="fas fa-box text-indigo-600 text-sm"></i>
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[9px] uppercase tracking-wider text-gray-400 font-bold">Box #</p>
          <p className="text-lg font-black text-gray-800 leading-none">42</p>
        </div>
      </div>
      <div className="pt-2 border-t border-gray-100 space-y-1.5">
        <div className="flex justify-between text-[10px]"><span className="text-gray-400">Name</span><span className="font-bold text-gray-800">Ayaz Khan</span></div>
        <div className="flex justify-between text-[10px]"><span className="text-gray-400">Tracking</span><span className="font-mono font-bold text-gray-800">1Z999AA10123456784</span></div>
        <div className="flex justify-between text-[10px]"><span className="text-gray-400">Carrier</span><span className="font-bold text-gray-800">UPS</span></div>
      </div>
    </div>
    <button className="w-full bg-gradient-to-r from-orange-500 to-pink-500 text-white text-xs font-bold py-3 rounded-xl shadow-lg mb-2 flex items-center justify-center gap-2">
      <i className="fas fa-map-location-dot"></i> Get Directions
    </button>
    <button className="w-full bg-white text-gray-700 text-xs font-bold py-3 rounded-xl shadow-sm border border-gray-200 flex items-center justify-center gap-2">
      <i className="fas fa-share"></i> Share with Someone
    </button>
  </div>
);

const AppComingSoon = () => {
  const features = [
    { icon: 'fa-camera-retro', title: 'Snap-to-scan', text: 'Point at your package slip. Done.' },
    { icon: 'fa-bell', title: 'Push alerts', text: 'Get notified the moment your package arrives.' },
    { icon: 'fa-map-location-dot', title: 'Store finder', text: 'One-tap directions to the shop.' },
    { icon: 'fa-shield-halved', title: 'Secure & private', text: 'Your data stays yours. End-to-end.' },
    { icon: 'fa-language', title: 'Bilingual', text: 'English & Dutch out of the box.' },
    { icon: 'fa-bolt', title: 'Blazing fast', text: 'Native performance on iOS & Android.' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-purple-950 to-slate-950 text-white overflow-hidden relative" data-testid="app-coming-soon-page">
      <div className="absolute top-20 -left-40 w-96 h-96 bg-indigo-600 rounded-full opacity-20 blur-3xl"></div>
      <div className="absolute top-96 -right-40 w-96 h-96 bg-pink-500 rounded-full opacity-20 blur-3xl"></div>
      <div className="absolute bottom-20 left-1/2 w-96 h-96 bg-orange-500 rounded-full opacity-15 blur-3xl"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 py-8">
        <Link to="/" className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 backdrop-blur-md rounded-full text-sm font-semibold transition-all border border-white/10" data-testid="back-home-link">
          <i className="fas fa-arrow-left"></i> Back home
        </Link>

        <div className="text-center mt-10 mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-gradient-to-r from-orange-500/20 to-pink-500/20 border border-orange-400/30 rounded-full text-xs uppercase tracking-widest font-bold mb-6" data-testid="soon-badge">
            <span className="w-2 h-2 bg-orange-400 rounded-full animate-pulse"></span>
            In active development
          </div>
          <h1 className="text-5xl sm:text-6xl md:text-7xl font-black leading-[0.95] tracking-tight mb-6">
            Ashop is going<br />
            <span className="bg-gradient-to-r from-orange-400 via-pink-400 to-purple-400 bg-clip-text text-transparent">mobile.</span>
          </h1>
          <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed mb-8">
            The Ashop Rotterdam app is being crafted with love. Track packages, get notified instantly, and skip the guesswork &mdash; all from your pocket.
          </p>
          <div className="flex items-center justify-center gap-3 flex-wrap mt-4">
            <button disabled className="inline-flex items-center gap-2 px-6 py-3 bg-black/60 border border-white/20 rounded-2xl text-sm font-semibold opacity-70 cursor-not-allowed">
              <i className="fab fa-apple text-xl"></i>
              <div className="text-left leading-none"><p className="text-[9px] opacity-70">Coming to</p><p className="text-base font-bold">App Store</p></div>
            </button>
            <button disabled className="inline-flex items-center gap-2 px-6 py-3 bg-black/60 border border-white/20 rounded-2xl text-sm font-semibold opacity-70 cursor-not-allowed">
              <i className="fab fa-google-play text-lg"></i>
              <div className="text-left leading-none"><p className="text-[9px] opacity-70">Coming to</p><p className="text-base font-bold">Google Play</p></div>
            </button>
          </div>
        </div>

        <div className="relative flex justify-center items-end gap-4 my-16 flex-wrap" data-testid="mockups-row">
          <div className="hidden md:block"><PhoneMockup rotate={-8} scale={0.85}><HomeScreen /></PhoneMockup></div>
          <div className="relative">
            <PhoneMockup rotate={0} scale={1}><ScannerScreen /></PhoneMockup>
            <div className="absolute -top-3 -right-3 bg-gradient-to-r from-orange-500 to-pink-500 text-white text-[10px] font-black px-3 py-1.5 rounded-full shadow-lg uppercase tracking-widest rotate-6">Preview</div>
          </div>
          <div className="hidden md:block"><PhoneMockup rotate={8} scale={0.85}><DetailsScreen /></PhoneMockup></div>
        </div>

        <div className="mt-24">
          <div className="text-center mb-10">
            <p className="text-xs uppercase tracking-[0.3em] text-orange-400 font-semibold mb-3">What&apos;s coming</p>
            <h2 className="text-3xl sm:text-4xl font-black">Everything you love, in your pocket</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {features.map((f) => (
              <div key={f.title} className="group bg-white/5 border border-white/10 rounded-2xl p-6 backdrop-blur-sm hover:bg-white/10 hover:border-white/20 transition-all">
                <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-orange-500 to-pink-500 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                  <i className={`fas ${f.icon} text-white`}></i>
                </div>
                <h3 className="text-lg font-bold mb-1">{f.title}</h3>
                <p className="text-sm text-gray-400 leading-relaxed">{f.text}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 mb-8 bg-gradient-to-r from-orange-500/20 via-pink-500/20 to-purple-500/20 border border-white/10 rounded-3xl p-8 text-center backdrop-blur-md">
          <p className="text-2xl sm:text-3xl font-black mb-2">Stay tuned.</p>
          <p className="text-gray-300 mb-5 max-w-xl mx-auto">We&apos;re polishing every pixel. In the meantime, you can keep tracking packages right here on the web.</p>
          <Link to="/customer" className="inline-flex items-center gap-2 px-6 py-3 bg-white text-slate-900 font-bold rounded-2xl hover:bg-gray-100 transition-all shadow-lg">
            <i className="fas fa-globe"></i> Use the web tracker <i className="fas fa-arrow-right"></i>
          </Link>
        </div>

        <p className="text-center text-xs text-gray-500 mt-8 mb-4">Ashop Rotterdam · Made with love in the port city</p>
      </div>
    </div>
  );
};

export default AppComingSoon;
